<template>
  <div class="user" :class="{active : activeType == 'user'}" ref="user">
    <div class="photo" >
      <i class="fa fa-user text-white" aria-hidden="true" style="margin: 10px"></i>
    </div>
    <div class="info">
      <a class="user-nm" data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="javascript:void(0)">
         <span>
           {{ checkAuth($store.state.account.roleCode, 'ADVERTISER:AGENT:BUILDER') ? $store.state.account.companyName : $store.state.account.userName }}
           <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu my-info" v-show="!isClosed">
            <li v-if="!checkAuth($store.state.account.roleCode, 'EMART')" :class="{active : activeType == 'user'}">
              <a href="javascript:void(0)" @click.prevent="editInfo">
                <!-- <span class="sidebar-mini-icon"><i class="fa fa-id-card-alt" aria-hidden="true"></i></span> -->
                <span class="sidebar-normal">내정보 수정</span>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" @click.prevent="logout">
                <!-- <span class="sidebar-mini-icon"><i class="fa fa-sign-out-alt" aria-hidden="true"></i></span> -->
                <span class="sidebar-normal">Logout</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import {CollapseTransition} from 'vue2-transitions'
  import Vue from 'vue';
  import store from '@/store';

  export default {
    components: {
      CollapseTransition
    },
    props: {
      activeType: String
    },
    data() {
      return {
        isClosed: true,
      }
    },
    mounted() {

      // console.log('USER',this.$router, this.$route)
      if(this.$route.name === 'SettingsAccountEdit') {
        this.isClosed = false
        this.active();
        this
      }

    },
    methods: {
      toggleMenu() {
        this.isClosed = !this.isClosed
      },
      logout() {
        store.dispatch('auth/logout');
      },
      editInfo() {

        Vue.router.push({
          name: 'SettingsAccountEdit',
          params: {userId: this.$store.state.account.userId},
          query: {myInfo: true}
        });

        this.active()

      },
      // 권한 확인
      checkAuth(roleCode, targetRoles) {
        return Vue.checkAuth(roleCode, targetRoles);
      },
      active() {
        this.$emit('activate', 'user' );
        setTimeout(()=>{
          //$('.scroll-content').find('.active').removeClass('active');
        },100);
      }
    }
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
  .my-info { padding-left: 17px; }

  .user.active { 
    background-color: #2e3c6b;
    border-radius: 4px;
  }  

  .sidebar .user {
    margin: 6px 12px;    
  }

  .sidebar .user-nm {
    padding-top: 14px; 
    padding-bottom: 14px;
  }

  .sidebar .user .photo {
    position: relative;
    top: 7px;
    margin-left: 17px;    
  }

  ul.nav.nav-menu.my-info {
    margin:0; padding:0;
  }

  .sidebar .user li {
    padding: 0 !important; margin: 0 !important;
    position: relative;
  }

  .sidebar .user .info .caret {
    right: 8px !important;
  }

  .sidebar .user li a {
    position: relative;
    display: block;
    padding: 10px 0 10px 35px !important;
    margin-top: 7px !important;
  }  

  .sidebar .user li.active a {
    background-color: #415091 !important;
    border-radius: 4px;    
  }

  .sidebar .user li.active a::after {
    content: '';
    position: absolute !important;
    width: 4px !important;
    height: 100%;
    background-color: white;
    left: 0;
    top: 0 !important;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    display: block !important;
    border: none !important;    
  }
</style>
